module.exports = __webpack_public_path__ + "img/250780534.4f0655e1.jpg";